<template>
    <div v-if="pending">{{ $t('loading') }} </div>
    <div v-else class="container py-5">
        <div>
            <h2>{{ $t('dataSpaceDetail') }}</h2>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'dataspaces' }">
                            {{ $t('home') }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="'/settings/dataspaces'">
                            {{ $t('dataSpaces') }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item">
                        {{ $t('detail') }}
                    </li>
                </ol>
            </nav>
        <div class="form-row">
            <div class="form-group col-md-3 mb-3">
                <label for="name" class="form-label mb-2">{{ $t('dataSpaceName') }}</label>
                <input v-model="model.name" type="text"  class="form-control" id="name"  placeholder="Enter dataSpace name">
            </div>
        </div>
        <div class="row col-md-12">
            <label class="form-label">{{ $t('groups') }}</label>
            <div class="col-md-3" v-for="(item, i) in groups" :key="i">
                <div class="input-group mb-3">
                    <label class="form-control readonly" :for="'group_' + i">{{item.name}}</label>
                    <div class="input-group-text">
                        <input class="form-check-input mt-0" type="checkbox" :id="'group_' + i" @change="groupCheck(item, $event)" :checked="isGroupChecked(item)">
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-4">
                <button type="button" class="btn btn-primary" @click="saveDataSpace">{{ $t('save') }}</button>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import DataSpaceApi from "../../../api/server/dataspace";
import GroupApi from "../../../api/server/group";

export default {
    name: "dataSpacedetail",    
    notifications: {
        showSuccess: { 
            title: 'Getan!',
            message: 'DataSpace was succesfully updated.',
            type: 'success'
        }
    },
    mounted() {
        this.requestData();
    },
    methods: {
        groupCheck(group, event) {
            if(!this.content.groups) this.content.groups = [];

            if(event.target.checked) {
                var index =  this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index < 0) {
                    this.content.groups.push({ "groupId": group.id })
                }
            } else {
                var index = this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index >= 0) {
                    this.content.groups.splice(index, 1);
                }
            }
        },
        isGroupChecked(item) {
            return this.content["groups"]?.findIndex(f => f["groupId"] == item.id) >= 0;
        },
        async saveDataSpace() {
            this.model.content = JSON.stringify(this.content);
            await DataSpaceApi.dataSpaceUpdate(this.model);
            this.showSuccess();
        },
        async requestData() {
            var model = await DataSpaceApi.dataSpaceDetail(this.$route.params.id);
            this.content = JSON.parse(model.content); 
            this.model = model;
            this.groups = await GroupApi.list();
            
            this.pending = false;
        }
    },
    data() {
        return {
            pending: true,
            groups: [],
            model: {
                name: "",
                groups: [],
            }
        }
    }
};
</script>